export enum UserAccountTypeEnum {
    MEMBER = 'R',
    ORGANIZER = 'O',
}
